import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import Spinner from '@/components/common/Spinner';

interface AdminGuardProps {
  children: React.ReactNode;
}

// Allow access on localhost without auth for development
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export default function AdminGuard({ children }: AdminGuardProps) {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  // Bypass auth on localhost for development
  if (isLocalhost) {
    return <>{children}</>;
  }

  if (isLoading) {
    return <Spinner fullScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
